const carModels: {
  [modelName: string]: string;
} = {
  asx: '/images/models/asx.png',
  'asx-new': '/images/models/asx-new.png',
  'eclipse-cross': '/images/models/eclipse-cross.png',
  'eclipse-cross-phev': '/images/models/eclipse-cross-phev.png',
  outlander: '/images/models/outlander.png',
  'outlander-phev': '/images/models/outlander-phev.png',
  'outlander-phev-new': '/images/models/outlander-phev-new.png',
  'space-star': '/images/models/space-star.png',
  colt: '/images/models/colt.png',
  grandis: '/images/models/grandis.png',
  'eclipse-cross-ev': '/images/models/eclipse-cross-ev.png',
  //lancer: '/images/models/lancer.png',
};

const getModalImage = (modelName: string): string | false => {
  return carModels[modelName] ? carModels[modelName] : false;
};

export default getModalImage;
